import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
// App Modules
import { SharedModule } from '../shared/shared.module';
import {PanotestComponent} from './panotest.component';
import {NgxWebstorageModule} from 'ngx-webstorage';
import {PanotestRoutingModule} from './panotest-routing.module';
import { DomSanitizer} from '@angular/platform-browser';
import {PanotestService} from './panotest.service';
import './models';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@NgModule({
  declarations: [
    PanotestComponent,
    SafePipe,
    SafeHtmlPipe
    ],


  imports: [
    PanotestRoutingModule,
    SharedModule,
    HttpClientModule,
    NgxWebstorageModule.forRoot(),

  ],
  providers: [PanotestService],
  entryComponents: [],
  exports: []
})
export class PanotestModule { }

